const FullscreenButton = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    fill='none'
    viewBox='0 0 24 24'
  >
    <rect width='24' height='24' fill='#121432' fillOpacity='.24' rx='4' />
    <path
      fill='#fff'
      fillRule='evenodd'
      d='M5.526 5.531a.667.667 0 0 1 .943-.005l3.334 3.3a.667.667 0 1 1-.939.948l-3.333-3.3a.667.667 0 0 1-.005-.943Zm4.281 8.667a.667.667 0 0 1-.004.943l-3.334 3.3a.667.667 0 1 1-.938-.948l3.333-3.3a.667.667 0 0 1 .943.005Zm4.422-.003c.26-.26.682-.26.943 0l3.3 3.3a.667.667 0 1 1-.943.943l-3.3-3.3a.667.667 0 0 1 0-.943Zm4.209-8.666c.26.26.26.682 0 .943l-3.3 3.3a.667.667 0 0 1-.943-.943l3.3-3.3c.26-.26.683-.26.943 0Z'
      clipRule='evenodd'
    />
    <path
      fill='#fff'
      fillRule='evenodd'
      d='M14.334 6c0-.368.298-.667.666-.667h3c.368 0 .667.299.667.667v3a.667.667 0 1 1-1.334 0V6.667H15A.667.667 0 0 1 14.334 6ZM18 14.334c.368 0 .667.298.667.666v3a.667.667 0 0 1-.667.667h-3a.667.667 0 1 1 0-1.334h2.334V15c0-.368.298-.666.666-.666Zm-12 0c.368 0 .667.298.667.666v2.334H9a.667.667 0 0 1 0 1.333H6A.667.667 0 0 1 5.333 18v-3c0-.368.299-.666.667-.666ZM5.333 6c0-.368.299-.667.667-.667h3a.667.667 0 1 1 0 1.334H6.667V9a.667.667 0 0 1-1.333 0V6Z'
      clipRule='evenodd'
    />
  </svg>
)

export default FullscreenButton
